import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import { getApi } from "../apiPath";
import { axiosClient } from "../clients";
import type { IPickCollectionQuery } from "../types";

import type { IAcademicGroups } from "./routeType";

const { key, getPath } = getApi("academicGroups.getAll");

type IExtractedRouteType = IAcademicGroups["academicGroupCollectionRetrieve"];

export type IGetAllAcademicGroup = IPickCollectionQuery<IExtractedRouteType>;

export const getAllAcademicGroup: Fetcher<
  IGetAllAcademicGroup["response"],
  IGetAllAcademicGroup["variables"]
> = ({ ...params }) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetAllAcademicGroup = createQuery({
  queryKey: [key],
  fetcher: getAllAcademicGroup,
});
